import {OfferType} from "../../offer/types/OfferType";
import {ISitemapRegionListRegion} from "../actions/fetch_site_map_region";
import {getRegionOfferCountByOfferType} from "./get_region_offer_count_by_offer_type";

export const isCollectionEmpty = (offerType: OfferType, collection: ISitemapRegionListRegion[]) => {
    return !collection.find((element) => getRegionOfferCountByOfferType(element, offerType));
};
import {OfferType} from "../../offer/types/OfferType";
import {ISitemapRegionListRegion} from "../actions/fetch_site_map_region";
import {getRegionOfferCountByOfferType} from "./get_region_offer_count_by_offer_type";

export const isCollectionEmpty = (offerType: OfferType, collection: ISitemapRegionListRegion[]) => {
    return !collection.find((element) => getRegionOfferCountByOfferType(element, offerType));
};
